import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import BusinessProfile from './business-profile';
import CreateProvider from './create-provider';
import CreateWorkspace from './create-workspace';
import DepartmentsStaff from './DepartmentsStaff';

const Provider: React.FunctionComponent = () => {
  const match = useRouteMatch();
  const { path } = match;

  return (
    <Switch>
      <Route exact path={`${path}/create-provider`} component={CreateProvider} />
      <Route
        exact
        path={`${path}/profile/departments/create-workspace/:workspaceId?`}
        component={CreateWorkspace}
      />
      <Route
        exact
        path={`${path}/profile/departments/staff/:workspaceId`}
        component={DepartmentsStaff}
      />
      <Route path={`${path}/profile`} component={BusinessProfile} />
      <Redirect to={`${path}/profile`} />
    </Switch>
  );
};

export default React.memo(Provider);
